import styled from 'styled-components';
import Button from '../../../../../../components/Button';
import { ButtonSmall } from '../../../../../../components/Text';
import Color from '@/utils/color';

export const ProductImage = styled.img`
  width: 150px;
  height: 150px;
`;

export const Field = styled.div`
  padding: 1rem 0;
`;

export const Select = styled.select`
  padding: 0.5rem 1rem;
  margin: 0.5rem 0;
`;

export const SaveCopyButton = styled(Button)`
  margin-left: 15px;
`;

export const CategoryLinkContainer = styled(ButtonSmall)`
  padding: 20px 0px;
`;
export const CategoryStoreLink = styled.a`
  color: ${Color.DarkSkyBlue};
  text-decoration: underline;
  margin-right: 5px;
`;

export const ProductButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
